import { load3DLogo } from '../../vendor/index.js';

export default {
  init() {
    /* Script pour le module vidéo avec curseur, preview et ligne élastique */
    $(
      '.module-conception-web .gform-body .gform_page_fields .gform_fields .evenement .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img, .module-conception-web .gform-body .gform_page_fields .gform_fields .gfield .ginput_container.ginput_container_checkbox .gfield_checkbox .gchoice.image-choices-choice .image-choices-choice-image-wrap img, .module-conception-web .gform-body .gform_page_fields .gform_fields .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img'
    ).each(function () {
      import_url_image = $(this).attr('src');
      console.log('hihihi')
      $(this)
        .parent()
        .css('mask-image', 'url(' + import_url_image + ')');
      $(this)
        .parent()
        .css('background-image', 'none');
    });

    $(
      '.popup_conception-web .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible.url .ginput_container_text'
    ).each(function () {
      $(this).append('<span class="focus-border"></span>');
    });

    $(
      '.popup_conception-web .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible label.gfield_label'
    ).each(function () {
      $(this).next().append($(this));
    });

    $(
      '.popup_conception-web .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input'
    ).each(function () {
      $(this).focusout(function () {
        if ($(this).val() != '') {
          $(this).addClass('has-content');
        } else {
          $(this).removeClass('has-content');
          $(this).val('');
        }
      });
    });

    $(
      '.popup_conception-web .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input'
    ).each(function () {
      if ($(this).val() != '') {
        $(this).addClass('has-content');
      } else {
        $(this).removeClass('has-content');
        $(this).val('');
      }
    });

    var import_url_image;
    let scene3D;

    MutationObserver =
      window.MutationObserver || window.WebKitMutationObserver;

    var observer = new MutationObserver(function (mutations, observer) {

      $(
        '.module-conception-web .gform-body .gform_page_fields .gform_fields .evenement .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img, .module-conception-web .gform-body .gform_page_fields .gform_fields .gfield .ginput_container.ginput_container_checkbox .gfield_checkbox .gchoice.image-choices-choice .image-choices-choice-image-wrap img, .module-conception-web .gform-body .gform_page_fields .gform_fields .ginput_container.ginput_container_radio .gfield_radio .gchoice.image-choices-choice .image-choices-choice-image-wrap img'
      ).each(function () {
        import_url_image = $(this).attr('src');
        $(this)
          .parent()
          .css('mask-image', 'url(' + import_url_image + ')');
        $(this)
          .parent()
          .css('background-image', 'none');
      });
    });

    observer.observe(document.getElementsByClassName('popup_conception-web')[0], {
      subtree: true,
      attributes: true,
    });


    function openPopup() {
      const logoContainer = $('.wrap_popup .logo_3d_conception_web');
      load3DLogo({ container: logoContainer[0], dark: true }).then((scene) => {
        scene3D = scene;
        scene3D.play();
      });

      $('.popup_conception-web').addClass('open');
      $('html').addClass('popup');
      $('.module-conception-web').css({ pointerEvents: 'auto' });
      if ($('.module-conception-web .popup_conception-web .popup_content').find('.gform_confirmation_wrapper').length !== 0) {
        $('.module-conception-web .popup_conception-web .wrap_popup .logo_3d').css('display', 'block');
      }
    }

    $('.iconweb').on('click', openPopup);

    $('.popup_conception-web .close').on('click', function () {
      $('.popup_conception-web').removeClass('open');
      $('html').removeClass('popup');
      $('.module-conception-web').css({ pointerEvents: 'none' });

      if (scene3D) {
        scene3D.pause();
      }
    });

    jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
      $(
        '.popup_conception-web .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last'
      ).each(function () {
        $(this).append('<span class="focus-border"></span>');
      });

      $(
        '.popup_conception-web .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone input, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email input, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first input, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last input'
      ).each(function () {
        $(this).focusout(function () {
          if ($(this).val() != '') {
            $(this).addClass('has-content');
          } else {
            $(this).removeClass('has-content');
            $(this).val('');
          }
        });
      });

      $(
        '.popup_conception-web .gform_body .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_text input, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_textarea textarea, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_phone input, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container_email input, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_first input, .popup_conception-web .gform_body .form_loading_pages_popup .gform_page_fields .gform_fields .gfield_visibility_visible .ginput_container .name_last input'
      ).each(function () {
        if ($(this).val() != '') {
          $(this).addClass('has-content');
        } else {
          $(this).removeClass('has-content');
          $(this).val('');
        }
      });

      $(
        '.popup_conception-web .gform_body  .gform_page_fields .gform_fields .gfield_visibility_visible label.gfield_label'
      ).each(function () {
        $(this).next().append($(this));
      });

      $('.popup_conception-web .gform_body  .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible .ginput_container_textarea').append(function () {
        var label_inside = $('.popup_conception-web .gform_body  .gform_page_fields .gform_fields .textarea_project.gfield_visibility_visible label.gfield_label');
        return label_inside;
      });

    });
  },
};
